module.exports = __webpack_public_path__ + "files/392908e6ac57972d861edd4634932027.png";